import Color from '@arcgis/core/Color.js';
import { DEFAULT_MAP_SOURCE } from '@env';

import { hexToRgb } from '@lib/common/helpers';

import { ShapeStylesType } from '../types/shape-styles.type';

import SimpleFillSymbolProperties = __esri.SimpleFillSymbolProperties;

export class FsShapeStyles {
  public styles: ShapeStylesType | SimpleFillSymbolProperties;
  private get defaultMapSource(): string {
    return DEFAULT_MAP_SOURCE;
  }

  constructor(private _styles: ShapeStylesType) {
    switch (this.defaultMapSource) {
      case 'esri':
        this.styles = this._handleEsriStyles();
        break;
      case 'google':
        this.styles = this._handleGoogleStyles();
        break;
    }
  }

  private _handleEsriStyles(): any {
    const fillColor = hexToRgb(this._styles.fillColor, this._styles.fillOpacity);
    const strokeColor = hexToRgb(this._styles.strokeColor, this._styles.strokeOpacity);
    return {
      style: this._styles.style,
      color: new Color(fillColor),
      outline: {
        color: new Color(strokeColor),
        width: this._styles.strokeWidth,
        style: this._styles.style,
        join: 'miter',
      },
    };
  }

  private _handleGoogleStyles(): any {
    return this._styles;
  }
}
